import axios from '@/axios/api.request'

export const save = (from) => axios.request({
  url: '/patent/pay/save',
  data: from,
  method: 'post'
})

export const quota = (from) => axios.request({
  url: '/patent/pay/quota',
  data: from,
  method: 'post'
})